function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy252(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M65.2,85.3H34.1c-6.1,0-11.1-5-11.1-11.1v-2.5c0-6.1,5-11.1,11.1-11.1h31.1c6.1,0,11.1,5,11.1,11.1v2.5 C76.3,80.3,71.3,85.3,65.2,85.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 36.1,
    cy: 72.9,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 63.1,
    cy: 72.9,
    r: 6.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M41.3,41.6c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S38,41.6,41.3,41.6 M41.3,39.6 c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8s8-3.6,8-8C49.3,43.2,45.7,39.6,41.3,39.6L41.3,39.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M57.9,41.6c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S54.6,41.6,57.9,41.6 M57.9,39.6 c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8s8-3.6,8-8C65.9,43.2,62.3,39.6,57.9,39.6L57.9,39.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M41.3,18.8c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4 C37.9,20.3,39.4,18.8,41.3,18.8 M41.3,16.8c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.4,5.4,5.4s5.4-2.4,5.4-5.4 C46.7,19.2,44.3,16.8,41.3,16.8L41.3,16.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M57.9,18.8c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4 C54.5,20.3,56,18.8,57.9,18.8 M57.9,16.8c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.4,5.4,5.4s5.4-2.4,5.4-5.4 C63.3,19.2,60.9,16.8,57.9,16.8L57.9,16.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M49.6,27.6c3.3,0,6,2.7,6,6s-2.7,6-6,6c-3.3,0-6-2.7-6-6S46.3,27.6,49.6,27.6 M49.6,25.6 c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C57.6,29.1,54,25.6,49.6,25.6L49.6,25.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M66.2,27.6c3.3,0,6,2.7,6,6s-2.7,6-6,6c-3.3,0-6-2.7-6-6S62.9,27.6,66.2,27.6 M66.2,25.6 c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C74.2,29.1,70.6,25.6,66.2,25.6L66.2,25.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M33,27.6c3.3,0,6,2.7,6,6s-2.7,6-6,6c-3.3,0-6-2.7-6-6S29.7,27.6,33,27.6 M33,25.6 c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C41,29.1,37.4,25.6,33,25.6L33,25.6z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M67.1,13.5H32.1c-5.9,5.2-9.5,12.9-9.1,21.4c0.7,13.4,11.5,24.4,24.9,25.2c15.5,1,28.3-11.3,28.3-26.6 C76.3,25.5,72.7,18.4,67.1,13.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M32.5,10.3h34.2c4.3,0,13.1,10.8,13.1,23.1v39.4c0,8.9-7.2,16.2-16.2,16.2H35.3c-8.8,0-16-7.2-16-16V33.5 C19.3,22.2,27.2,10.3,32.5,10.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy252);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-252.6cba5af0433bdfce703c9a9d30a5587d.svg";
export { ForwardRef as ReactComponent };